import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { changeLanguage, interpolateString } from '../translations/i18nUtils';
import i18next from '../translations/i18n';

const LabelContext = React.createContext();

export function useLabelContext() {
    const context = useContext(LabelContext);

    if (!context) {
        throw new Error(
            'useLabelContext must be used within a LabelContextProvider. Wrap a parent component in <LabelContextProvider to fix this error'
        );
    }

    return context;
}

export function LabelContextProvider(props) {
    useTranslation('translation');

    const [contextValue, setContextValue] = useState({});

    useEffect(() => {
        changeLanguage(props.siteLanguage);
        setContextValue({
            ...i18next.getDataByLanguage(props.siteLanguage).translation,
            interpolateString,
        });
    }, [props.siteLanguage]);

    return (
        <LabelContext.Provider value={contextValue}>
            {props.children}
        </LabelContext.Provider>
    );
}

LabelContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
    siteLanguage: PropTypes.string,
};
